import type { ClubMessageData } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import produce from 'immer';

import type { PageData } from '../../types/common';

export const setAnnouncement = (
  state: PageData,
  { response }: { response: (ClubMessageData & { created?: string }) | null }
) =>
  produce(state, (draft) => {
    draft.announcement = response;
  });

export const clearAnnouncement = (state: PageData) =>
  produce(state, (draft) => {
    draft.announcement = null;
  });
